import React from "react";
import ToolTip from "./ToolTip";
import { TEMPLATE_TYPES } from "../../Utils/constants";
import { dashboardColors, theme } from "../../themes/Theme";

const Accordion = props => {
	const onClick = label => {
		props.onAccordionClick(label);
	};

	return (
		<>
			<div>
				<AccordionSection
					isOpen={Array.isArray(props.accordion) ? props.accordion.includes(props.children.props.label) : props.accordion == props.children.props.label}
					label={props.children.props.label}
					onClick={onClick}
					props={props}
				>
					{props.children.props.children}
				</AccordionSection>
			</div>
		</>
	);
};

const AccordionSection = ({ isOpen, label, onClick, props }) => {
	return (
		<div>
			<div
				className={isOpen ? `active accordion mt-4 px-4 py-3` : `accordion mt-4 px-4 py-3`}
				onClick={() => onClick(label)}
				style={{ cursor: "pointer" }}
			>
				{props.children.props.icon != null && props.children.props.icon}
				{label} {props.children.props.referalls != null && props.children.props.referalls}
				{props.children.props.tooltip != null && (
					<ToolTip data={props.children.props.tooltip} />
				)}
				{props.children.props.questionIcon != null && props.children.props.questionIcon}
				<div style={{ float: "right", transform: "translateY(4px)" }}>
					{!isOpen && (
						<span
							style={{
								color: "#6C757D"
							}}
						>
							<i className="fas fa-chevron-down"></i>
						</span>
					)}
					{isOpen && (
						<span
							style={{
								color: "#6C757D"
							}}
						>
							<i className="fas fa-chevron-up"></i>
						</span>
					)}
				</div>
				{props.children.props.desc != null && (
					<div className="accordion-description"> {props.children.props.desc} </div>
				)}
			</div>
			{isOpen && (
				<div
					className={
						isOpen
							? `${props.children.props.padding == "no" ? "p-0" : "p-4"
							} activeAccodion`
							: "panel"
					}
				>
					{props.children}
				</div>
			)}

			<style jsx>{`
				label {
					color:  ${dashboardColors[theme].primaryTextColor};
				}
				.accordion {
					cursor: pointer;
					padding: 18px;
					width: 100%;
					text-align: left;
					transition: 0.4s;
					background-color: #ffffff;
					border: 2px solid #d7d7d7;
					border-radius: 2px;
					color:  ${dashboardColors[theme].primaryTextColor};
					// box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
					// 	rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
				}
				.accordion-description {
					color: #6C757D;
                    font-size: 14px;
                    font-weight: 400;
				}		
				.panel {
					padding: 0 18px;
					background-color: white;
					display: none;
					overflow: hidden;
				}

				.activeAccodion {
					// box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
					// 	rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
					border-radius: 2px;
					border: 2px solid #d7d7d7;
					// box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
					border-top: transparent;
					background: ${(props.accordion === TEMPLATE_TYPES.emailTemplates ||
					props.accordion === TEMPLATE_TYPES.smsTemplates ||
					props.accordion === TEMPLATE_TYPES.whatsappTemplates
				) &&
					(props.data?.campaign_status === 1)
					? "#D7D7D7"
					: "#fff"};
				}
			`}</style>
		</div>
	);
};

export default Accordion;
